import { render, staticRenderFns } from "./PricingPage.vue?vue&type=template&id=0b21e4a3&scoped=true"
import script from "./PricingPage.vue?vue&type=script&lang=ts"
export * from "./PricingPage.vue?vue&type=script&lang=ts"
import style0 from "./PricingPage.vue?vue&type=style&index=0&id=0b21e4a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b21e4a3",
  null
  
)

export default component.exports